import React, {useState} from 'react'
import {Divider, FormHelperText} from "@material-ui/core";
import TextInput from "components/TextInput";
import Tr from "translations/Translations";
import SortableContainer from "components/complex/sortable/SortableContainer";
import PurchasingGroupTemplateField from "./PurchasingGroupTemplateField";
import PurchasingGroupTemplateAggregatedFieldsPopup from "./PurchasingGroupTemplateAggregatedFieldsPopup";
import Button from "components/Button";
import getObjectValue from "libs/getObjectValue";
import PlusOneIcon from "@material-ui/icons/PlusOne";
import BoldTypography from "components/BoldTypography";

function PurchasingGroupTemplateForm(
    {
        formikProps,
        hasEdit,
    }) {

    const [aggregatedFieldId, setAggregatedFieldId] = useState(null);
    const fieldsErrorValue = hasEdit ? getObjectValue("fieldsCount", formikProps.errors, '') : '';

    const addField = () => {
        const fields = getObjectValue("fields", formikProps.values, []);
        const newFields = [...fields];
        newFields.push({
            identity: 0,
            uniqueId: "ftf_" + Math.random().toString(36).substring(2),
            name: "",
            ordinalNumber: 0,
            type: "NUMBER",
            required: true,
            aggregatedFields: []
        })
        formikProps.setFieldValue("fields", newFields, true)
    }


    return <>
        <TextInput
            formikProps={formikProps}
            id="name"
            label={Tr('name')}
            required
            limit={250}
            disabled={!hasEdit}
            multiline
        />
        <TextInput
            formikProps={formikProps}
            id="description"
            label={Tr('description')}
            required
            multiline
            limit={1000}
            disabled={!hasEdit}
        />

        <BoldTypography>Pola szablonu</BoldTypography>
        <FormHelperText error>{fieldsErrorValue}</FormHelperText>

        <SortableContainer
            formikProps={formikProps}
            id="fields"
        >
            {(formikProps, id, index) => {
                return (
                    <div>
                        <PurchasingGroupTemplateField
                            id={id}
                            formikProps={formikProps}
                            index={index}
                            setAggregatedFieldId={setAggregatedFieldId}
                            hasEdit={hasEdit}
                        />
                        <Divider />
                    </div>
                )
            }}
        </SortableContainer>

        {hasEdit &&<Button Icon={PlusOneIcon} onClick={addField}>{Tr("add_field")}</Button>}

        {
            !!aggregatedFieldId && <PurchasingGroupTemplateAggregatedFieldsPopup fieldId={aggregatedFieldId} formikProps={formikProps} onClose={()=> setAggregatedFieldId(null)} />
        }
    </>

}

PurchasingGroupTemplateForm.propTypes = {}

export default PurchasingGroupTemplateForm;
	
